import type {EventHashedID, EventVO} from '@Components/events/events.types';
import type {LoadingStates} from '@Utils/loading.util';
import type {SocialPost} from '@Components/social-media/post.vo';
import type {EmailCampaign, EmailCampaignId} from '@Components/email-marketing-campaigns/email-marketing-campaigns.types';

export type PromotionSteps = PromotionStep[];

export interface MystuffEventPromotionPageProps {}

export enum PromotionType {
  EVENT_PAGE = 'event-page',
  SHARE_EVENT_PAGE_LINK = 'share-event-page-link',
  SOCIAL_POSTS = 'social-posts',
  EMAIL_CAMPAIGNS = 'email-campaigns',
  EMBED_IN_WEBPAGE = 'embed-in-webpage',
  PRINT_FLYERS = 'print-flyers',
}

// codeReviewShahrukh: a base interface maybe?

export interface EventPromotionStateBase {
  event: EventVO;
  stats: EventStats;
  promotionSteps: PromotionSteps;
  socialPosts: SocialPost[];
  emailCampaigns: EmailCampaign[];
  printFlyers: PrintFlyerPoster[];
  showOneClickPromotionBanner: boolean;
  areEventPreviewsReady: boolean;
}

export interface EventPromotionReducerState extends EventPromotionStateBase {
  loadingState: LoadingStates;
  mobileViewActivePromotionType?: PromotionType;
}

export type FetchEventPromotionResponse = EventPromotionStateBase;

export interface EventStats {
  views: number;
  registrations: number;
  reach: number;
}

export interface PrintFlyerPoster {
  posterId: number;
  posterHashedID: string;
  previewImageURL: string;
  isVideo: boolean;
  posterName: string;
  isPreviewOutdated: boolean;
  idcreator: number;
  previewVideoURL?: string;
  isLoading?: boolean;
}

export interface EventPromotionMetrics {
  numPageViews: number;
  totalReach: number;
  numRegistrations: number;
}

export interface PromotionStep {
  type: PromotionType;
  isCompleted: boolean;
  isSkipped: boolean;
  sortOrder: number;
}

export interface PromotionStepAjaxParams {
  promotionType: PromotionType;
  eventHashedID: EventHashedID;
}

export interface DeleteSocialPostFromEventAjaxParams {
  eventHashedID: EventHashedID;
  socialPostId: string;
}

export interface EventEmailCampaignAjaxParams {
  eventHashedID: EventHashedID;
  emailCampaignId: EmailCampaignId;
}

export interface DeletePosterFromEventAjaxParams {
  eventHashedID: EventHashedID;
  posterHashedId: string;
}

export type EventPromotionTypeCallback = (promotionType: PromotionType) => void;